import { axiosInstance } from '~/src/config/config_axios'
import { convertLanguage } from '~/src/repositories/Other/helpers/ConvertLanguage'
import {
  ILanguageResponse,
  IDownloadsBody,
  IDownloadsResponse,
  IGetFileUpload,
  IPutFileUploadResponse,
  IProductResponse,
} from '~/src/repositories/Other/models/Other'
import { convertProduct } from './helpers/ConvertProduct'
import { convertLoadingPort } from './helpers/ConvertLoadingPort'
import { convertSupplier } from './helpers/ConvertSupplier'

export class OtherRepository {
  async getLanguage(): Promise<ILanguageResponse[]> {
    const response = await axiosInstance.get('/languages')
    return convertLanguage(response.data)
  }

  /**
   * getDownloadFileUrl
   * @param customHeader
   */
  async getDownloadFileUrl(customHeader: any = {}): Promise<IGetFileUpload['data']> {
    const data = await axiosInstance.get('/fileupload-url', {
      headers: customHeader,
    })
    return data.data
  }

  /**
   * deprecation:　putFileUploadを使用
   */
  async putFile(file: File, url: string) {
    const res = await axiosInstance.put(url, file, { headers: { 'Content-Type': file.type } })
    return res.data
  }

  /**
   * putFileUpload
   * @param url
   * @param file
   */
  async putFileUpload(url: string, file: File): Promise<IPutFileUploadResponse['data'] | string> {
    if (!file) return 'error'
    return await axiosInstance.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    })
  }
  /**
   * getDownloads
   */
  async getDownloads(): Promise<IDownloadsResponse> {
    const { data } = await axiosInstance.get('/downloads')
    return data
  }

  /**
   * postDownloads
   * @param data
   */
  async patchDownloads(data: IDownloadsBody) {
    const res = await axiosInstance.patch('/downloads', data)
    return res.data
  }

  /**
   * getProducts
   */
  async getProducts(): Promise<IProductResponse[]> {
    const res = await axiosInstance.get('/products')
    return convertProduct(res.data)
  }

  /**
   * getLoadingPorts
   */
  async getLoadingPorts(): Promise<ILoadingPortResponse[]> {
    const res = await axiosInstance.get('/loading-ports')
    return convertLoadingPort(res.data)
  }

  /**
   * getSuppliers
   */
  async getSuppliers(): Promise<ISupplierResponse[]> {
    const res = await axiosInstance.get('/suppliers')
    return convertSupplier(res.data)
  }

}
